module.exports = __webpack_public_path__ + "static/media/gold-progress.2978fcde.png";